/**
 * Styled wrappers shared by the cart table's cells. Also imported by the checkout order-details
 * cells (`components/Shared/CheckoutOrderDetails/CheckoutOrderDetailsTable/Helper/`) and the
 * Easy Quote table cells (`components/EasyQuote/Helper/TableComponents/`), so a style change here
 * reaches those tables too.
 */
import styled from "@emotion/styled";
import { Flex } from "@ryerson/frontend.layout";
import { Alert } from "@ryerson/frontend.notification";

/**
 * Full-size flex box at least 30px tall that holds one cell's content. Despite the name, it wraps
 * body cells as well as column headers.
 */
export const DataTableHeader = styled(Flex)`
	width: 100%;
	height: 100%;
	min-height: 30px;
`;

/** Full-width `Alert`, the body of `./ShoppingCartAlert.tsx` → `ShoppingCartAlert`. */
export const StyledAlert = styled(Alert)`
	width: 100%;
	max-width: 100%;
`;
